export Slider from './Slider'

export default from './Slider'



// WEBPACK FOOTER //
// ./src/Slider/index.js